export const socialsData = {
  github: "https://github.com/bulbul1434/",
  whatsapp: "whatsapp://send?text=hello&phone=9754057360",
  linkedIn: "https://www.linkedin.com/in/bulbul",
  instagram: "https://www.Instagram.com/i.m.bulbul20/"
};
